// ONDEMAND-1: RecordingDetail's "Auto-transcription" line — the server's one-sentence reason
// this recording will/won't transcribe on its own, plus (for its owner) a per-recording
// override. Rendered only when the feature is enabled.
//
// The override is shown to the owner only: the server allows editors too, but a Recording
// carries no caller-permission field to tell an editor from a viewer, and offering a control
// that 403s for viewers would be worse than hiding it from the (rare) non-owner editor.
import { useId } from 'react';
import type { Recording, TranscriptionPolicy } from '@scribe/core/types';
import {
  useRecordingTranscriptionStatus,
  useSetRecordingTranscriptionPolicy,
} from '../../lib/ondemandQueries';
import { useMe } from '../../lib/queries';

export function AutoTranscribeSection({ recording }: { recording: Recording }) {
  const { data: me } = useMe();
  const canEdit = me != null && me.id === recording.owner_id;
  const { data: status } = useRecordingTranscriptionStatus(recording.id, true);
  const setPolicy = useSetRecordingTranscriptionPolicy(recording.id);
  const selectId = useId();

  return (
    <div className="row-secondary">
      <h3 className="label" style={{ marginBottom: 8 }}>
        Auto-transcription
      </h3>
      {status && <p className="muted">{status.auto_transcribe.reason}</p>}
      {canEdit && (
        <div className="field">
          <label className="label" htmlFor={selectId}>
            This recording
          </label>
          <select
            id={selectId}
            value={recording.transcription_policy ?? ''}
            disabled={setPolicy.isPending}
            onChange={(e) =>
              setPolicy.mutate((e.target.value || null) as TranscriptionPolicy | null)
            }
          >
            <option value="">Use default</option>
            <option value="immediate">Transcribe automatically</option>
            <option value="on_access">Only when opened</option>
          </select>
        </div>
      )}
      {setPolicy.isError && <p className="error">{(setPolicy.error as Error).message}</p>}
    </div>
  );
}
